import React from "react";
import {ShimmerBlock, ShimmerRows} from "./Shimmer";

/**
 * Indicateur de chargement des pages : un shimmer (carte squelette) plutôt qu'une roue.
 * Nom historique conservé : la plupart des écrans l'importent encore. Pour un nouvel écran,
 * utiliser directement `Shared/Shimmer` (ShimmerRows, ShimmerTableRows, ShimmerChart).
 */
const FecthingSpinner = ({rows = 6, label}) => (
    <div className="card" aria-busy="true">
        <div className="body">
            <ShimmerBlock width="40%" height={18} className="mb-3" />
            <ShimmerRows rows={rows} label={label} />
        </div>
    </div>
);

export default FecthingSpinner;
